import { ErrorLocale } from "@/locales/localeid";
import { Result } from "ant-design-vue";
import { fmtMsg } from "commonui";
import { Component, Vue } from "vue-property-decorator";

@Component({
	components: {
		"a-result": Result
	}
})
export default class Unauthorized extends Vue {
	get message() {
		return fmtMsg(ErrorLocale.UnauthorizedMessage);
	}

	refresh() {
		window.history.go();
	}
}
